import styled, { css } from "styled-components";

export const PreviewRoot = styled.label`
  display: block;
  cursor: pointer;
  padding: 0;
  width: 90px;
`;

export const PreviewCard = styled.div<{ $checked: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  padding: 8px;
  border: 1px solid ${({ theme }) => theme.cayoTheme.brandColors.divider};
  background-color: ${({ theme }) => theme.cayoTheme.brandColors.primaryBackground};
  width: 90px;
  min-height: 90px;
  box-sizing: border-box;

  ${({ $checked }) =>
    $checked &&
    css`
      border-color: ${({ theme }) => theme.cayoTheme.brandColors.primaryHighlight};
      box-shadow: inset 0 0 0 2px ${({ theme }) => theme.cayoTheme.brandColors.primaryHighlight};
    `}
`;

export const PreviewSwatches = styled.div`
  display: flex;
  flex-direction: column;
  width: 50px;
  height: 50px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.cayoTheme.brandColors.divider};
  background-color: ${({ theme }) => theme.cayoTheme.brandColors.secondaryBackground};
  flex-shrink: 0;
`;

export const PreviewSwatch = styled.div<{ $color?: string | null; $isPlaceholder?: boolean }>`
  position: relative;
  flex: 1 1 0;
  width: 100%;
  background-color: ${({ $color, theme }) =>
    $color ?? theme.cayoTheme.brandColors.primaryBackground};

  ${({ $isPlaceholder }) =>
    $isPlaceholder &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #ffffff;
      color: #000000;
      font-size: 12px;
      font-weight: 600;

      &::after {
        content: "?";
      }
    `}
`;

export const PreviewLabel = styled.span`
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.officeTheme.semanticColors.bodyText};
  display: block;
  width: 100%;
  text-align: center;
`;
